var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "The-card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "The-Card---Desktop",
    transform: "translate(-723.000000, -1190.000000)",
    fill: "#E5E1EB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(119.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.275458,344.711028 C611.094091,344.896512 610.846644,345 610.589604,345 C610.332564,345 610.085116,344.896512 609.903749,344.711028 L604.426328,339.141091 C603.857891,338.563146 603.857891,337.625974 604.426328,337.049113 L605.112182,336.351607 C605.680797,335.773663 606.601487,335.773663 607.169923,336.351607 L610.589604,339.828664 L619.830077,330.433458 C620.398691,329.855514 621.320269,329.855514 621.887818,330.433458 L622.573672,331.130965 C623.142109,331.708909 623.142109,332.645901 622.573672,333.222942 L611.275458,344.711028 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheckIcon);
export default __webpack_public_path__ + "static/media/gray_check_icon.49af6635a3f1751d0b5da82f2705635a.svg";
export { ForwardRef as ReactComponent };